import { Injectable, ErrorHandler, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';
import { LoggingService } from './services/logging/logging.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
  })
export class JsErrorHandler implements ErrorHandler {
  constructor(
      public dialog: MatDialog,
      private router: Router,
      private zone: NgZone,
      private logging: LoggingService,
      private translate: TranslateService,

  ) {}

  async handleError(error) {
    console.error(error);

    this.zone.run(() => {
      this.logging.logError(error.stack).subscribe(() => {});
    });
  }
}
